import Table from "react-bootstrap/Table";

import { formatCurrency, capitalizeString } from "../../utilities/helpers";

export default function LeaderBoard({ data }) {
  if (!data) return;
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Rank</th>
            <th>Sales Rep</th>
            <th>Tickets Sold</th>
            <th>Comp Tickets Issued</th>
            <th>Revenue Generated</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.ranked?.map((d, idx) => (
              <tr key={idx}>
                <td>{d?.rank}</td>
                <td>{capitalizeString(d?.salesRep)}</td>
                <td>{d?.ticketsSold}</td>
                <td>{d?.ticketsComps}</td>
                <td>{formatCurrency(d?.revenue)}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
}
